<template>
  <div class="container h-100">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col-11 col-md-4">
        <form @submit.prevent="submit">
          <h2 class="text-center mb-3">dmp 管理画面</h2>
          <h5 class="text-center mb-5">パスワードのリセット</h5>
          <div class="mb-3">
            <input type="email" class="form-control" v-model="email" placeholder="メールアドレス" required>
          </div>
          <div class="mb-3">
            <input type="password" class="form-control" v-model="password" placeholder="パスワード" required>
          </div>
          <div class="mb-3">
            <input type="password" class="form-control" v-model="passwordConfirm" placeholder="パスワード（確認）" required>
          </div>
          <div class="mb-3">
            <button class="btn btn-primary w-100" :disabled="!validated">パスワードを更新</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {resetPassword} from '../../../api/admin/AuthApi';
import useFlashMessage from '../../../composables/useFlashMessage';

const email = ref();
const password = ref();
const passwordConfirm = ref();

const route = useRoute();
const router = useRouter();
const {successMessage, errorMessage} = useFlashMessage();

const validated = computed(() => {
  if (!email.value) {
    return false;
  }

  if (!password.value) {
    return false;
  }

  if (passwordConfirm.value !== password.value) {
    return false;
  }

  return true;
});

/**
 * ログイン
 *
 * @returns {Promise<void>}
 */
const submit = async () => {
  try {
    await resetPassword({
      email: email.value,
      password: password.value,
      password_confirmation: passwordConfirm.value,
      token: route.params.token
    });

    successMessage('パスワードを再設定しました。');

    await router.push({name: 'admin.login'});
  } catch (e) {
    errorMessage(e.message);
  }
}
</script>
